import React, { useState } from 'react';
import { Button, Alert, Spinner } from 'reactstrap';
import { useMutation } from '@apollo/react-hooks';
import { TOGGLE_COLOR_FEATURE } from '../../../mutation/mutation';
import { GET_BOX_DATA } from '../../../query/query';

const toggleColorFeatureMutationFunction = ({ boxId }) => useMutation(TOGGLE_COLOR_FEATURE, {
  update(cache, { data: { savToggleColorFeature: hasColor } }) {
    if (typeof hasColor !== 'boolean') return;
    const { savGetBoxData } = cache.readQuery({
      query: GET_BOX_DATA,
      variables: { boxId },
    });
    savGetBoxData.hasColor = hasColor;
    cache.writeQuery({ query: GET_BOX_DATA, variables: { boxId }, data: { savGetBoxData } });
  },
});

export default ({ boxId, hasColor, refetchBox }) => {
  const [toggleColorFeatureMutation] = toggleColorFeatureMutationFunction({ boxId });
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleColorFeature = async () => {
    setError(false);
    setLoading(true);
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(
      `⚠️ Are you sure to ${hasColor ? 'des' : ''}activate color feature on this box ?`,
    );
    if (!confirm) {
      setLoading(false);
      return;
    }
    try {
      await toggleColorFeatureMutation({ variables: { boxId } });
      await refetchBox();
      setLoading(false);
    } catch (e) {
      setError(true);
      setLoading(false);
    }
  };

  return (
    <div>
      {loading
        ? (<Spinner color="primary" />)
        : (
          <Button
            type="submit"
            color="primary"
            onClick={toggleColorFeature}
          >
            {`${hasColor ? 'Desactivate' : 'Activate'} Color Feature`}
          </Button>
        )}
      {error && (
        <Alert color="danger">
          An error occured when trying to toggle the color feature on this box.
        </Alert>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/infos/toggle-color-feature.js